import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { NoteType } from "../_enums/NoteType";
import { ResourceType } from "../_enums/ResourceType";
import { INote } from "./notes.service.ajs";

@Injectable({
    providedIn: 'root'
})
export class FoundationNotesService {
    constructor(private readonly http: HttpClient) { }

    getNotes(entityId: number, resourceType: ResourceType, noteType: NoteType): Observable<INote[]> {
        return this.http.get<INote[]>(`/api/foundation/notes/${ResourceType[resourceType]}/${entityId}`).pipe(map(notes => {
            const filteredNotes = notes.filter(n => n.NoteType == noteType);

            filteredNotes.forEach(note => {

                note.noteTypeString = NoteType[note.NoteType];
            });

            return filteredNotes;

        }))
    }

    addNote(note: INote): Observable<INote> {

        return this.http.post<INote>(`/api/foundation/notes/`, note);
    }
}
